import React from 'react';

import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';

import {
    GridApi,
    GridExportButton,
} from '@instinet-analytics/semantic-ui-components';
import IndexEventsWidgetGridColumnPicker from './IndexEventsWidgetGridColumnPicker';
import { useIndexEventsPortfolioRequirements } from '../../use-index-events-portfolio-requirements';
import { ControlledSelectionStatus } from 'portfolio/components/SelectionStatus';
import { useIndexEventsConfigSlice } from '../../store/config/configSlice';
import IndexEventsTradeCategoryDropdown from './IndexEventsTradeCategoryDropdown';
import IndexEventsSideDropdown from 'widgets/indexEvents/components/toolbar/IndexEventsSideDropdown';
import { IndexEventsSettings } from '../IndexEventsSettings';

import './IndexEventsWidgetToolbar.scss';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';

export default function IndexEventsWidgetToolbar({
    gridApi,
}: {
    gridApi?: GridApi;
}) {
    const requirements = useIndexEventsPortfolioRequirements();

    const { config, dispatchConfigChanged } = useIndexEventsConfigSlice();

    const { side, tradeCategories } = config;

    const onChangeTradeCategories = (nextTradeCategories: string[]) => {
        dispatchConfigChanged({ tradeCategories: nextTradeCategories });
    };
    const onChangeSide = (nextSide: string | undefined) => {
        dispatchConfigChanged({ side: nextSide });
    };

    return (
        <WidgetToolbarShowHidePanel mustShow={!requirements.meetsRequirements}>
            <div className="IndexEventsWidgetToolbar panel-header">
                {!requirements.meetsRequirements && (
                    <div className="toolbar">
                        <ControlledSelectionStatus
                            message={requirements.alert!}
                        />
                    </div>
                )}

                {requirements.meetsRequirements && (
                    <div className="toolbar">
                        <IndexEventsTradeCategoryDropdown
                            tradeCategories={tradeCategories}
                            onChangeTradeCategories={onChangeTradeCategories}
                        />
                        <IndexEventsSideDropdown
                            side={side}
                            onChangeSide={onChangeSide}
                        />
                    </div>
                )}

                <WidgetToolbar
                    messages={[]}
                    settingsHeader={`Index Events Settings`}
                    settingsBody={<IndexEventsSettings />}
                    settingsTriggerText={`Index Events Settings`}
                    settingsClassName="IndexEventsSettings"
                    fixedItems={
                        <>
                            <GridExportButton
                                csvFileName={'IndexEventsWidget'}
                                gridApi={gridApi}
                            />
                            <IndexEventsWidgetGridColumnPicker />
                        </>
                    }
                />
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
